/*
 *  Copyright (c) Qwoach LLC 2026. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 */

export const TlswStageEnum = Object.freeze({
	STAGE_INITIAL: "STAGE_INITIAL",
	STAGE_MIDWAY: "STAGE_MIDWAY",
	STAGE_END: "STAGE_END",
})

export const TlswStageOrder = [
	TlswStageEnum.STAGE_INITIAL,
	TlswStageEnum.STAGE_MIDWAY,
	TlswStageEnum.STAGE_END,
]
